"use client";

import CtaBannerSection from "./CtaBannerSection";

/** Public CTA props, kept in one place; was previously inlined on `/how-delivery-works` as `CtaBannerSection`. */
export const HOLY_SHIT_DEALS_CTA = {
  ariaLabel: "Holy Shit Deals",
  heading: "Holy Shit Deals!",
  description:
    "Top-quality cannabis doesn't have to be expensive. From cheap ounces to discounted edibles and pre-rolls, our menu is constantly updated with new steals.\nGrab the best weed for less",
  ctaText: "View Latest Drops",
  ctaHref: "/search?deals=true",
} as const;

/**
 * “Holy Shit Deals” promo, same block as on `/how-delivery-works` (see git history: was `CtaBannerSection` there).
 * Replaces the older image-only banner (`holy-shit-deals.png`) so the CTA is consistent and clickable.
 */
export default function HolyShitDealsSection() {
  return <CtaBannerSection {...HOLY_SHIT_DEALS_CTA} />;
}
